import React, { useState } from "react";
import { Keyboard } from "../../../types/keyboard/keyboard.enum";
import { TextField } from "../text-field/text-field.component";
import { EditInPlaceProps } from "./edit-in-place.props";
import { EditInPlaceTextContainer } from "./edit-in-place.styles";

export const EditInPlace = (props: EditInPlaceProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const { editable = true } = props;

  const onBlur = (event: any) => {
    setIsEditing(false);
    props.onChange(event.target.value);
  };

  const edit = () => setIsEditing(editable);

  const onKeyDown = (event: any) => {
    if (event.key === Keyboard.Enter) {
      event.target.blur();
    }

    if (event.key === Keyboard.Escape) {
      event.target.value = props.value;
      event.target.blur();
    }
  };

  return (
    <>
      <EditInPlaceTextContainer
        tabIndex={editable ? 0 : -1}
        showIf={!isEditing}
        editable={editable}
        onClick={edit}
        onFocus={editable ? edit : undefined}
      >
        {props.render()}
      </EditInPlaceTextContainer>
      <TextField
        showIf={isEditing}
        autoFocus
        defaultValue={props.value}
        fullWidth
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        variant="outlined"
      />
    </>
  );
};
